import React from "react";
import {format} from "date-fns";
import {Button} from "../../../general/input/Button";
import GoogleMapReact from 'google-map-react';
import {shipmentService} from "../../../../res/dataServices/shipmentService";
import HeaderLink from "./HeaderLink";
import CompactOrder from "./CompactOrder";
import CompactInvoice from "./CompactInvoice";
import {useNavigate} from "react-router-dom";

const DriverLocation = ({lat, lng}) => {
    const defaultProps = {
        center: {
            lat, lng
        },
        zoom: 12
    };

    return (
        <div style={{ height: '200pt', width: '200pt' }}>
            <GoogleMapReact
                bootstrapURLKeys={{ key: "" }}
                defaultCenter={defaultProps.center}
                defaultZoom={defaultProps.zoom}
            >
                <div style={{height: "10pt", width: "10pt", background: "red"}}
                     lat={lat}
                     lng={lng}
                />
            </GoogleMapReact>
        </div>
    );
}

const ActiveDeliveryInfo = ({shipment}) => {
    if(!shipmentService.isOutForDelivery(shipment)) return null;

    const arrivalMessage = shipmentService.getExpectedArrivalMessage(shipment);
    const dropsAhead = Number(shipment.dropsAhead);

    return (
        <>
            <p className="account-tile-content-b">{arrivalMessage}</p>
            {dropsAhead > 0 ?
                <p className="account-tile-content-b">Your order is
                    <span style={{color: "var(--primary)", fontWeight: "bold"}}> {dropsAhead}</span> stops away
                </p>
                : <p className="account-tile-content-b">Your delivery is next!</p>
            }
        </>
    )

}

const HeaderShipment = ({shipment, orders, invoices}) => {

    const navigate = useNavigate();
    const onSeeFullDetails = () => {
        navigate("/account/ordering/shipments/" + shipment.id);
    }

    const documentNo = shipment.DocumentNo;
    const deliveryDate = format(shipmentService.getDeliveryDate(shipment), "dd/MM/yy")
    const locationName = shipment["C_BPartner_Location_ID"].Name;
    shipmentService.getDeliveryDate(shipment);

    const statusMsg = shipmentService.getStatusMessage(shipment);

    const isDelivered = !shipmentService.isInProgress(shipment);
    const ofd = shipmentService.isOutForDelivery(shipment);
    const displayDriverLocation = ofd && shipment.latitude && shipment.longitude;
    const bodyClassName = displayDriverLocation ? "shipment-tile-body" : "account-tile-body"

    return (
        <div className="tile shipment-tile">
            <div className="tile-header account-tile-header-container">
                <div className="account-tile-header-detail">
                    <p className="account-tile-h">Shipment</p>
                    <p className="account-tile-h">Delivery Date</p>
                    <p className="account-tile-h">Location</p>
                    <p className="account-tile-b" style={{color: "var(--primary)"}}>{documentNo}</p>
                    <p className="account-tile-b">{deliveryDate}</p>
                    <p className="account-tile-b">{locationName}</p>
                </div>
                <HeaderLink txt="Order(s)">
                    {(orders && orders.length > 0) ?
                        orders.map((e,i) =>
                            <CompactOrder key={i} order={e} />
                        )
                        : <p className="account-link-empty">There are no invoices linked to this order</p>
                    }
                </HeaderLink>
                <HeaderLink txt="Invoice(s)">
                    {(invoices && invoices.length > 0) ?
                        invoices.map((e,i) =>
                            <CompactInvoice key={i} invoice={e} />
                        )
                        : <p className="account-link-empty">There are no invoices linked to this order</p>
                    }
                </HeaderLink>
            </div>
            <div className={bodyClassName}>
                <div className="account-tile-content">
                    <p className="account-tile-content-h">Status</p>
                    <p className="account-tile-content-b">{statusMsg}</p>
                    <ActiveDeliveryInfo shipment={shipment} />
                </div>
                <div className="account-tile-action">
                    {isDelivered && <Button className="button_clear">Return Items</Button>}
                    <Button onClick={onSeeFullDetails}>See Full Details</Button>
                </div>
                {displayDriverLocation &&
                    <div className="delivery-tile-map-container">
                        <DriverLocation lat={shipment.latitude} lng={shipment.longitude} />
                    </div>
                }
            </div>
        </div>
    )

}

export default HeaderShipment;